import camelCase from "lodash/camelCase";
import { FilterList } from "@/types/filters.type";

type SearchFilterFields<TConditions extends FilterList> = Partial<Record<Extract<keyof TConditions, string>, string>>;

export const getSearchByField = <TConditions extends FilterList>(
  conditions: TConditions,
  searchString: string,
): SearchFilterFields<TConditions> => {
  const newSearchField: SearchFilterFields<TConditions> = {};
  Object.keys(conditions)
    .filter((item) => conditions[item].kind === "search")
    .forEach((item) => {
      const searchFieldKey = camelCase(item) as Extract<keyof TConditions, string>;
      newSearchField[searchFieldKey] = searchString;
    });
  return newSearchField;
};
